package com.ervasstudio.tracoemovimento.pages.home.mobile

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Composable
fun TracoEMovimentoSectionMobile() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .position(Position.Relative)
            .padding(top = 16.px, bottom = 24.px, left = 20.px, right = 20.px)   // era 30/50/100/60
    ) {
        Image(
            src = "/seta_glow.png",
            modifier = Modifier.position(Position.Absolute).top(4.px).right(8.px).width(90.px)   // era 280.px
        )
        Image(
            src = "/xish.png",
            modifier = Modifier.position(Position.Absolute).bottom(12.px).left(8.px).width(90.px)   // era 280.px
        )

        Column(
            modifier = Modifier.fillMaxSize().padding(top = 60.px, bottom = 40.px),   // era 150/130
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                "TRAÇO",
                modifier = Modifier.fontSize(44.px).fontFamily("Gotham")   // era 160.px
                    .fontWeight(FontWeight.Black).color(Colors.Black)
            )
            SpanText(
                "E MOVIMENTO",
                modifier = Modifier.fontSize(44.px).fontFamily("Gotham")   // era 160.px
                    .fontWeight(FontWeight.Black).margin(top = (-6).px).color(Colors.Black)
            )
            SpanText(
                "O Traço e Movimento é um projeto desenvolvido pelo Ervas Studio. Nasce com a " +
                    "missão de formar uma nova geração de animadores, valorizando o traço africano, o " +
                    "olhar moçambicano e o poder do movimento como linguagem cultural.",
                modifier = Modifier.display(DisplayStyle.Block).textAlign(TextAlign.Justify)
                    .fontSize(15.px).fontFamily("museomoderno").fontWeight(FontWeight.Light)   // era 27.px
                    .fillMaxWidth()   // era width(74.cssRem)
                    .margin(top = 12.px, bottom = 8.px).color(Colors.Black)
            )
            SpanText(
                text = "Através de cursos, laboratórios e experimentação visual" +
                    "o projecto cria um espaço onde jovens artistas podem " +
                    "aprender, praticar e transformar ideias em animação " +
                    "com identidade própria, rigor técnico e imaginação" +
                    " sem limites.",
                modifier = Modifier.fontSize(15.px).fontFamily("museomoderno").fontWeight(FontWeight.Light)   // era 27.px
                    .fillMaxWidth()   // era width(74.cssRem)
                    .textAlign(TextAlign.Justify)
                    .margin(bottom = 40.px).color(Colors.Black)   // era 150.px
            )
            Row(modifier = Modifier.fillMaxWidth().height(16.px)) {}
        }
    }
}